/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const setLoopFinancialsRequestSchema = z.object({
  budgetAmount: z
    .string()
    .describe('Budget amount for this loop. Null clears the budget.')
    .nullish(),
});
